
import camelcaseKeys from 'camelcase-keys'

export class Currency {
  constructor (params = {}) {
    const { id, name, type, displayName } = camelcaseKeys(params)
    this.id = id || null
    this.name = name || null
    this.type = type || null
    this.displayName = displayName || null
  }
}
